export const TWILIO_CALL_STATE = {
  IDLE: 'idle', // no call in progress
  CONNECTING: 'connecting', // dialing out
  RINGING: 'ringing', // incoming call ringing
  CONNECTED: 'connected', // active call
  DISCONNECTED: 'disconnected', // call ended
  FAILED: 'failed', // error occurred
};
